<template>
  <div>
    <div class="main">
      <div class="form-row">
        <div class="form-field">
          <b>Вы вошли по временному паролю. Пожалуйста, введите новый пароль</b>
        </div>
        <div class="form-field">
          <label for="password-input">Пароль:</label>
          <input id="password-input" v-model="password" type="password" />
        </div>
        <div class="form-field">
          <label for="reg-fio-input">Повторите пароль:</label>
          <input id="reg-fio-input" v-model="confirmPassword" type="password" />
        </div>
        <div class="form-field">
          <button @click="send">
            Обновить пароль
          </button>
        </div>
      </div>
      <div class="form-row" v-if="info">{{ info }}</div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "change-password",
  data() {
    return {
      url: config.backend_url,
      password: null,
      confirmPassword: null,
      info: null
    };
  },
  computed: {
    auth: function() {
      return this.$store.getters["auth/isAuthenticated"];
    }
  },
  methods: {
    send: function() {
      const { password, confirmPassword } = this;
      if (password === confirmPassword) {
        this.$store
          .dispatch("query/sendRequest", {
            url: this.url + "users/change-password",
            data: { password: password },
            method: "POST"
          })
          .then(response => {
            let data = response.data;
            if (data.response) {
              this.$store.commit("auth/notTempPassword");
              alert("Пароль успешно обновлен. Авторизуйтесь заново");
              this.$store.dispatch("auth/authLogout");
            }
            console.log(data);
          });
      } else {
        alert("Пароли не совпадают");
      }
    },
    goToHome: function() {
      this.$router.push("/");
    }
  },
  mounted() {}
};
</script>
